export const toIds = <K extends string | number, T extends { id: K }>(arr: T[]) => arr.map(({ id }) => id);
